<template>
  <div>
    <div class="cert-header d-flex py-4">
      <div class="col-12 col-md-11 col-lg-10 col-xl-9 px-3 p-md-0 mx-auto">
        <div class="cert-title cert-large mt-3 mt-xl-0">Report a Vulnerability</div>
      </div>
    </div>
    <div ref="message" class="col-12 col-md-11 col-lg-10 col-xl-9 cert-announcement my-4 mx-auto py-3 px-4">You can
      contact us directly at <strong>vulnerability@ncsa.gov.rw</strong>
      <strong>
        <a href="//cyber.gov.rw/index.php?eID=dumpFile&t=f&f=335&token=511c8f3fdc72246b8c8995dff6718928404bbce9"
           target="_blank" style="width: fit-content">
          <micon icon="file_download" class="material-icons-outlined"/>
          <span style="margin-left: 8px">PGP Key</span>
        </a>
      </strong>
    </div>
    <div class="col-12 col-md-11 col-lg-10 col-xl-9 p-2 p-sm-5 mx-auto mt-2 mt-sm-3 cert-page-content d-flex">
      <form class="row g-3 mt-0" @submit="reportVulnerability">
        <argon-alert class="alert-success alert-dismissible" v-if="responseSuccess">
          Vulnerability reported successfully
        </argon-alert>
        <argon-alert class="alert-danger alert-dismissible" v-if="responseError">
          Something went wrong
        </argon-alert>
        <div class="col-md-6">
          <label for="inputEmail4" class="form-label required">First Name</label>
          <input type="text" class="form-control" id="inputEmail4" v-model="first_name" required>
          <div v-if="!validation.first_name.status" style="color: red">{{ validation.first_name.message }}</div>
        </div>
        <div class="col-md-6">
          <label for="inputEmail4" class="form-label required">Last Name</label>
          <input type="text" class="form-control" id="inputEmail4" v-model="last_name" required>
          <div v-if="!validation.last_name.status" style="color: red">{{ validation.last_name.message }}</div>
        </div>
        <div class="col-md-6">
          <label for="inputEmail4" class="form-label required">Organization Name</label>
          <input type="text" class="form-control" id="inputEmail4" v-model="organization_Name">
          <div v-if="!validation.organization_Name.status" style="color: red">{{
              validation.organization_Name.message
            }}
          </div>
        </div>
        <div class="col-md-6">
          <label for="inputPassword4" class="form-label required">Telephone</label>
          <input type="tel" class="form-control" id="inputPassword4"
                 v-model="telephone_number" required
                 :class="{ valid: isValidPhoneNumber, invalid: !isValidPhoneNumber }">
          <div v-if="!validation.telephone_number.status" style="color: red">{{ validation.telephone_number.message }}
          </div>
        </div>
        <div class="col-md-12">
          <label for="exampleFormControlInput1" class="form-label required">Email address</label>
          <input type="email" class="form-control" id="exampleFormControlInput1" v-model="email_address"
                 placeholder="name@example.com" required>
          <div v-if="!validation.email_address.status" style="color: red">{{ validation.email_address.message }}</div>
        </div>
        <div class="col-md-12">
          <label for="exampleFormControlTextarea1" class="form-label required">Description of the vulnerability</label>
          <textarea class="form-control" v-model="overview_vulnerability" rows="3"></textarea>
          <div v-if="!validation.overview_vulnerability.status" style="color: red">
            {{ validation.overview_vulnerability.message }}
          </div>
        </div>
        <div class="col-12">
          <button type="submit" class="btn btn-primary" :disabled="disableSubmit">Submit</button>
        </div>
      </form>
    </div>
  </div>
</template>
<style scoped>

</style>
<script>
import axios from "axios";
import validators from "@/assets/helper/validators";
import ArgonAlert from "@/components/ArgonAlert";

export default {
  name: "reportvulnerability",
  data() {
    return {
      overview_vulnerability: null,
      organization_Name: null,
      email_address: null,
      telephone_number: null,
      last_name: null,
      first_name: null,
      isValidPhoneNumber: true,
      responseSuccess: false,
      responseError: false,
      reCaptchaResponse: false,
      reCaptchaError: false,
      disableSubmit: false,
      validation: {
        organization_Name: {status: true, message: null},
        first_name: {status: true, message: null},
        last_name: {status: true, message: null},
        telephone_number: {status: true, message: null},
        overview_vulnerability: {status: true, message: null},
        email_address: {status: true, message: null}
      }
    };
  },
  components: {
    ArgonAlert,
  },
  methods: {
    verifyMethod() {
      this.reCaptchaResponse = true;
      this.reCaptchaError = false;
    },
    expiredMethod() {
      this.reCaptchaResponse = false;
    },
    errorMethod() {
      this.reCaptchaResponse = false;
    },
    validationReportVulnerabilityStatus() {
      this.validation.organization_Name = validators.validateText("Organization name", this.organization_Name);
      this.validation.first_name = validators.validateText("First name", this.first_name);
      this.validation.last_name = validators.validateText("Last name", this.last_name);
      this.validation.telephone_number = validators.validatePhoneNumber(this.telephone_number);
      this.validation.email_address = validators.validateEmailAddress(this.email_address);
      this.validation.overview_vulnerability = validators.validateText("Overview about the vulnerability", this.overview_vulnerability);
      return this.validation.organization_Name.status && this.validation.first_name.status && this.validation.last_name.status &&
          this.validation.telephone_number.status && this.validation.overview_vulnerability.status && this.validation.email_address.status;

    },
    reportVulnerability(e) {
      e.preventDefault();
      let vulnerabilityData = {
        organizationName: this.organization_Name,
        firstName: this.first_name,
        lastName: this.last_name,
        phoneNumber: this.telephone_number,
        incidentDescription: this.overview_vulnerability,
        email: this.email_address,
        incidentType: "VULNERABILITY",
      };
      if (this.validationReportVulnerabilityStatus()) {
        this.disableSubmit = true;
        axios.post(`${process.env.VUE_APP_BASE_URL}incident/insert`, vulnerabilityData)
            .then((response) => {
              this.applicationId = response.data;
              this.responseSuccess = true;
              setTimeout(() => this.responseSuccess = !this.responseSuccess, 12000);
              this.clear();
              this.disableSubmit = false;
            })
            .catch(error => {
              this.responseError = !this.responseError;
              setTimeout(() => this.responseError = !this.responseError, 12000);
              this.errorMessage = error.message;
              console.error("There was an error!", error);
              this.disableSubmit = false;
            });
      }
    },
    clear() {
      this.title_vulnerability = null;
      this.organization_Name = null;
      this.first_name = null;
      this.last_name = null;
      this.telephone_number = null;
      this.overview_vulnerability = null;
      this.email_address = null;
    },
    validatePhoneNumber() {
      const validationRegex = /^\+?\d{10,12}$/;
      if (this.telephone_number.match(validationRegex)) {
        this.isValidPhoneNumber = true;
      } else {
        this.isValidPhoneNumber = false;
      }
    }
  }
};
</script>

